import axios from 'axios';
import { getUrl } from '../../MIS/Global';

const api = axios.create({
  baseURL: getUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getMainProduct = async () => {
  try {
    const response = await api.get('mainproduct/');    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};

export const getSubProduct = async (data) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    const response = await api.get(`sub-product/?${queryParams}`);    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};




export default {
  getMainProduct,
  getSubProduct
};